type NoPaymentCardProps = Omit<React.SVGProps<SVGSVGElement>, 'width' | 'height'> & {
  size: number;
};

export const NoPaymentCard = ({ size, ...props }: NoPaymentCardProps) => {
  const height = Math.round(size * 0.625); // Credit card aspect ratio

  return (
    <svg
      {...props}
      width={size}
      height={height}
      viewBox="0 0 120 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Card background with dashed border */}
      <rect
        width="120"
        height="80"
        rx="4"
        fill="#f9fafb"
        stroke="#d1d5db"
        strokeWidth="2"
        strokeDasharray="6 4"
      />

      {/* Plus icon in center */}
      <g transform="translate(60, 40)">
        <circle cx="0" cy="0" r="12" fill="#e5e7eb" />
        <path d="M-6 0h12M0 -6v12" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" />
      </g>

      {/* "Add Payment Method" text placeholder lines */}
      <rect x="20" y="55" width="80" height="3" rx="1.5" fill="#e5e7eb" />
      <rect x="35" y="62" width="50" height="3" rx="1.5" fill="#e5e7eb" />
    </svg>
  );
};
